import { Route, Switch, useLocation } from 'wouter'
import { useAuth } from './contexts/AuthContext'
import Home from './pages/Home'
import NotFound from './pages/NotFound'
import AdminLogin from './pages/admin/Login'
import AdminDashboard from './pages/admin/Dashboard'
import StagesManager from './pages/admin/StagesManager'
import SubmissionsList from './pages/admin/SubmissionsList'
import LogsList from './pages/admin/LogsList'
import SettingsManager from './pages/admin/SettingsManager'
import DocumentsManager from './pages/admin/DocumentsManager'
import ReportsManager from './pages/admin/ReportsManager'
import FaqManager from './pages/admin/FaqManager'
import { useEffect } from 'react'

function PrivateRoute({ component: Component, ...rest }: any) {
  const { isAuthenticated, isLoading } = useAuth()
  const [, navigate] = useLocation()

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate('/admin/login')
    }
  }, [isLoading, isAuthenticated, navigate])

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#51A64D] mx-auto mb-4"></div>
          <p className="text-gray-500">Carregando...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return null
  }

  return <Component {...rest} />
}

function AppRoutes() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/admin/login" component={AdminLogin} />
      <Route path="/admin/dashboard" component={() => <PrivateRoute component={AdminDashboard} />} />
      <Route path="/admin/stages" component={() => <PrivateRoute component={StagesManager} />} />
      <Route path="/admin/settings" component={() => <PrivateRoute component={SettingsManager} />} />
      <Route path="/admin/documents" component={() => <PrivateRoute component={DocumentsManager} />} />
      <Route path="/admin/reports" component={() => <PrivateRoute component={ReportsManager} />} />
      <Route path="/admin/faq" component={() => <PrivateRoute component={FaqManager} />} />
      <Route path="/admin/submissions/contact" component={() => <PrivateRoute component={SubmissionsList} />} />
      <Route path="/admin/logs" component={() => <PrivateRoute component={LogsList} />} />
      <Route component={NotFound} />
    </Switch>
  )
}

export default AppRoutes